import { z } from 'zod'
import type { KaiascanClient } from './client'

type GetBlockNumberByTimestampParameters = {
  client: KaiascanClient
  timestamp: number
  closest?: 'before' | 'after'
  headers?: Record<string, string>
}

const resultSchema = z.union([z.string(), z.number()]).transform((value) => {
  const text = value.toString()
  if (!/^\d+$/.test(text)) {
    throw new TypeError(`Invalid block number: ${text}`)
  }
  return Number(text)
})

/**
 * Kaiascan から timestamp に対応する block number を取得する。
 *
 * @param parameters - client、Unix 秒 timestamp、closest、headers。
 * @returns block number。
 */
export const getBlockNumberByTimestamp = async ({
  client,
  timestamp,
  closest = 'before',
  headers,
}: GetBlockNumberByTimestampParameters): Promise<number> =>
  client.get({
    path: '',
    query: {
      module: 'block',
      action: 'getblocknobytime',
      timestamp: timestamp.toString(),
      closest,
    },
    resultSchema,
    headers,
  })
